export default __webpack_public_path__ + "static/media/blogpost-cards.4d72b596.jpg";